import styles from "@/styles/Header.module.scss";
import ActiveLink from "@/components/ActiveLink";
import ScrollMenu from "@/components/ScrollMenu";
import { useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";

function AuthorizedPrimaryNavigationForSp({ loggedIn }) {
  if (!loggedIn) return null;
  return (
    <div className={styles.primaryNavigationForSp}>
      <ScrollMenu className={styles.primaryNavigationForSpInner}>
        <div className={`${styles.slideItem} ${styles.homeLink}`}>
          <ActiveLink className={styles.slideItemLink} href={routes.home}>
            <span>ホーム</span>
          </ActiveLink>
        </div>

        <div className={styles.slideItem}>
          <ActiveLink
            className={styles.slideItemLink}
            href={routes.myList}
            matchtype="partial"
          >
            <span>マイリスト</span>
          </ActiveLink>
        </div>
      </ScrollMenu>
    </div>
  );
}
function NotAuthorizedPrimaryNavigationForSp({ loggedIn }) {
  if (loggedIn) return null;

  return (
    <div className={styles.primaryNavigationForSp}>
      <ScrollMenu className={styles.primaryNavigationForSpInner}>
        <div className={`${styles.slideItem} ${styles.homeLink}`}>
          <ActiveLink className={styles.slideItemLink} href={routes.home}>
            <span>ホーム</span>
          </ActiveLink>
        </div>
      </ScrollMenu>
    </div>
  );
}
// export default memo(PrimaryNavigation);
export default function PrimaryNavigationForSp() {
  const { loading, data } = useAuthUserQuery({ fetchPolicy: "cache-first" });
  const loggedIn = !loading && data?.user;

  return (
    <>
      <NotAuthorizedPrimaryNavigationForSp loggedIn={loggedIn} />
      <AuthorizedPrimaryNavigationForSp loggedIn={loggedIn} />
    </>
  );
}
